import React from "react";

// Shared popover footer used by every picker: a neutral "Clear selection" text
// link on the left (turns red on hover) and a fixed-size primary confirm button
// on the right. The Ok button keeps a consistent size across every picker.
const PickerFooter = ({ onClear, onConfirm, confirmLabel = "Ok", clearDisabled = false, confirmDisabled = false }) => {
    return (
        <div className="flex items-center justify-between gap-3">
            <button type="button" onClick={onClear} disabled={clearDisabled}
                className="text-sm font-medium text-content_2 underline underline-offset-2 hover:text-red-600 disabled:opacity-40 disabled:cursor-not-allowed disabled:no-underline disabled:hover:text-content_2 transition-colors">
                Clear selection
            </button>
            <button type="button" onClick={onConfirm} disabled={confirmDisabled}
                className="h-[40px] w-[120px] rounded-2xl bg-emp text-white font-semibold hover:bg-emp_dark disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                {confirmLabel}
            </button>
        </div>
    );
};
export default PickerFooter;
